import { render, staticRenderFns } from "./lkuMaintenreq.vue?vue&type=template&id=07859dd2"
import script from "./lkuMaintenreq.vue?vue&type=script&lang=js"
export * from "./lkuMaintenreq.vue?vue&type=script&lang=js"
import style0 from "./lkuMaintenreq.vue?vue&type=style&index=0&id=07859dd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports